import { render } from "./AppointmentDetail.vue?vue&type=template&id=d74b4a90&scoped=true"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js"

import "./AppointmentDetail.vue?vue&type=style&index=0&id=d74b4a90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d74b4a90"]])

export default __exports__